import React from 'react';

export const UnbrokenSignal = () => {
  return (
    <section className="mrm2-signal-section">
      <div className="mrm2-signal-content-wrapper">
        <div className="mrm2-signal-text">
          <h2 className="mrm2-signal-title">
            <span className="mrm2-signal-title-span">ROCK-SOLID</span>{' '}
            <span className="mrm2-signal-title-span">SIGNAL</span>
          </h2>
          <p className="mrm2-signal-description">
            Engineered for contested airspaces, the EW-resilient IRONghost link
            provides a secure, jam-resistant connection on licensed sub-GHz
            bands. Paired with a robust analog video feed, the result is
            real-time intelligence and total control at unparalleled operational
            ranges.
          </p>
        </div>
      </div>
    </section>
  );
};
